/* eslint-disable no-bitwise */

export default function arrayBufferToBase64(buffer: ArrayBuffer): string {
    let base64 = "";
    const encodings = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

    const bytes = new Uint8Array(buffer);
    const byteLength = bytes.byteLength;
    const byteRemainder = byteLength % 3;
    const mainLength = byteLength - byteRemainder;

    let a: number;
    let b: number;
    let c: number;
    let d: number;
    let chunk: number;

    for (let i = 0; i < mainLength; i += 3) {
        chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];

        a = (chunk & 0xfc_0000) >> 18;
        b = (chunk & 0x03_f000) >> 12;
        c = (chunk & 0x00_0fc0) >> 6;
        d = chunk & 0x00_003f;

        base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d];
    }

    if (byteRemainder === 1) {
        chunk = bytes[mainLength];

        a = (chunk & 0xfc) >> 2;
        b = (chunk & 0x03) << 4;

        base64 += `${encodings[a] + encodings[b]}==`;
    } else if (byteRemainder === 2) {
        chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1];

        a = (chunk & 0xfc00) >> 10;
        b = (chunk & 0x03f0) >> 4;
        c = (chunk & 0x000f) << 2;

        base64 += `${encodings[a] + encodings[b] + encodings[c]}=`;
    }

    return base64;
}
